import script from "./ServiceReview.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceReview.vue?vue&type=script&setup=true&lang=js"

import "./ServiceReview.vue?vue&type=style&index=0&id=1295811c&scoped=true&lang=css"

import exportComponent from "D:\\PROJECT\\Mbf5_HCC\\XaTanHungHph\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1295811c"]])

export default __exports__